<template>
  <div class="images">
    <div class="image" v-for="(item,index) in img_files" :key="index">
      <input type="hidden" hidden readonly :name="name" :value="item._id">
      <img :src="item.img_url" class="img" alt=""/>
      <i @click="removeFile(index)" class="fas fa-trash-can del-btn"></i>
    </div>

  </div>
  <button type="button"  @click="openFileManager = true" class="btn btn-info btn-sm">افزودن فایل</button>
  <FileManager :gallery="true" v-if="openFileManager" @closeFileManager="openFileManager =false" @changeFile="addFiles" ></FileManager>
</template>

<script>
import FileManager from "@/components/FileManager";
export default {
  name: "ImagePickerGallery",
  components: {FileManager},
  props:{name : {type : String},
  files : {type : Array}
  },
  data()
  {
    return{
      img_files :[],
      openFileManager:false,
    }
  },
  mounted()
  {
    this.img_files = (this.files?this.files:[]);
    console.log(this.img_files)
  },
  methods : {
    addFiles(img_files)
    {
      for (let i = 0; i < img_files.length; i++)
      {
        this.img_files.push(img_files[i]);
      }
      console.log(this.img_files)
    },
    removeFile(index)
    {
      this.img_files.splice(index,1);
    }
  }
}
</script>

<style scoped>
.images
{
  display: flex;
  overflow-x: auto;
  padding: 5px;
}
.images .image
{
  flex: 0 0 90px;
  height: 90px;
  margin-left: 5px;
  border: 1px solid silver;
  border-radius: 10px;
  position: relative;
}
.images .image img
{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.del-btn
{
  position: absolute;
  font-size: 16px;
  left: 0;
  top: 0;
  padding: 5px;
  cursor: pointer;
  color: #dc3545;
}
</style>